<template>
    <div class="container-fluid">
        <nav class="navbar navbar-expand-lg navbar-light row">
            <router-link class="navbar-brand" to="/"></router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div id="main-nav" class="collapse navbar-collapse">
                <ul class="navbar-nav ml-auto">
                  <router-link v-for="(page, index) in highlightedPage"
                               :key="'menu-highlighted' + index"
                               :to="{ path: page.children ? `/page/${page.slug}/${page.children[0].slug}`  : `/page/${page.slug}` }"
                               tag="li" class="ml-2 nav-item d-flex">
                    <a class="nav-link text-primary border border-primary bg-warning p-1" style="align-self: center">{{page.title}}</a>
                  </router-link>
                  <a
                               href="https://centrum.domcek.org"
                               target="_blank"
                               tag="li" class="ml-2 nav-item d-flex">
                    <a class="nav-link text-primary border border-primary bg-warning p-1" style="align-self: center">Centrum pre mládež</a>
                  </a>
                    <router-link :to="{ name: 'home', query: { p: 1} }"  tag="li" class="nav-item">
                        <a class="nav-link">{{ $t('pages.Home') }}</a>
                    </router-link>

                    <router-link v-for="(page, index) in pages"
                                 :key="'menu-page-xs' + index"
                                 tag="li"
                                 :to="{ path: page.children ? `/page/${page.slug}/${page.children[0].slug}`  : `/page/${page.slug}` }"
                                 class="d-xl-none d-lg-none nav-item">
                        <a class="nav-link">{{page.title}}</a>
                    </router-link>
                    <router-link v-for="(page, index) in pages"
                                 :key="'menu-page-lg' + index"
                                 tag="li"
                                 :to="{ path: page.children ? `/page/${page.slug}/${page.children[0].slug}`  : `/page/${page.slug}` }"
                                 :class="(page.children ?
                                     'dropdown dropdown-hover-toggle d-none  d-lg-inline-block nav-item ' :
                                     'd-none d-lg-inline-block nav-item ') + isActive(`/page/${page.slug}`)">
                        <a class="nav-link">{{page.title}}</a>
                        <div v-if="page.children && page.children.length > 0" class="dropdown-menu">
                            <router-link :to="{ path: `/page/${page.slug}/${child.slug}` }" class="dropdown-item"
                                         v-for="child in page.children"
                                         :key="child.id">
                                {{child.title}}
                            </router-link>
                        </div>
                    </router-link>
                    <router-link to="/contact" tag="li" class="nav-item">
                        <a class="nav-link">{{ $t('pages.Contact') }}</a>
                    </router-link>
                    <li class="nav-item dropdown dropdown-hover-toggle hidden-sm hidden-xs user-menu" v-if="user && user.profile">
                        <a class="user-icon nav-link">
                            <img :src="user.avatar" v-if="user.avatar" class="rounded-circle">
                            <i class="fa fa-user-circle" v-else></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <div class="text-white pl-3 pr-3 user-email">{{user.email}}</div>
                            <div class="dropdown-divider mb-0 mt-0"></div>
                            <router-link to="/admin/events" class="dropdown-item" v-if="user.admin">
                                {{ $t('button.AdminPortal') }}
                            </router-link>
                            <router-link to="/user/profile" class="dropdown-item">
                                {{ $t('button.UserProfile') }}
                            </router-link>
                            <router-link to="/user/events" class="dropdown-item" v-if="availableEvents.length && canRegister()">
                                {{ $t('button.RegisterToEvent') }}
                            </router-link>
                            <router-link to="/user/registrations" class="dropdown-item" v-if="availableEvents.length && canRegister()">
                                {{ $t('button.MyRegistrations') }}
                            </router-link>
                            <router-link to="/logout" class="dropdown-item">
                                {{ $t('button.Logout') }}
                            </router-link>
                        </div>
                    </li>
                    <router-link to="/login"  tag="li" class="nav-item" v-else>
                        <a class="nav-link">{{ $t('pages.Login') }}</a>
                    </router-link>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {can_register} from "../../utils/user";
  const highlightedPages = ['cesta-putnika']
  const hiddenPages = ['centrum-pre-mladez']

  export default {
    name: 'Nav',
    computed: {
      ...mapGetters(['getMenuPages', 'user', 'availableEvents']),
      highlightedPage() {
        return this.getMenuPages.filter((page) => highlightedPages.indexOf(page.slug) >
          -1).filter((item) => hiddenPages.indexOf(item.slug) === -1)
      },
      pages() {
        return this.getMenuPages.filter((page) => highlightedPages.indexOf(page.slug) === -1).filter((item) => hiddenPages.indexOf(item.slug) === -1)
      }
    },
    methods: {
      isActive(page) {
        return this.$route.path.startsWith(page) ? 'active' : '';
      },
      canRegister() {
        return can_register(this.user);
      }
    }
  };
</script>

<style scoped>

</style>
